customElements.get("share-button") || customElements.define("share-button", class extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.elements = {
      shareButton: this.querySelector("button"),
      shareSummary: this.querySelector("summary"),
      successMessage: this.querySelector('[id^="ShareMessage"]'),
      urlInput: this.querySelector("input")
    };
    this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
    this.mainDetailsToggle.addEventListener("toggle", this.toggleDetails.bind(this));
    this.mainDetailsToggle.querySelector(".share-button__input").addEventListener("click", this.copyToClipboard.bind(this));
    this.mainDetailsToggle.querySelector(".share-button__copy").addEventListener("click", this.copyToClipboard.bind(this));
    this.mainDetailsToggle.querySelector(".share-button__close").addEventListener("click", this.close.bind(this));
    if (navigator.share) {
      this.mainDetailsToggle.setAttribute("hidden", "");
      this.elements.shareButton.classList.remove("hidden");
      this.elements.shareButton.addEventListener("click", async () => {
        try {
          await navigator.share({ url: this.urlToShare, title: document.title });
        } catch (error) {
          if (error && error.name === "AbortError") return;
          this.elements.shareButton.classList.add("hidden");
          this.mainDetailsToggle.removeAttribute("hidden");
          this.mainDetailsToggle.open = true;
          this.elements.shareSummary.setAttribute("aria-expanded", "true");
          this.elements.shareSummary.focus();
        }
      });
    }
  }
  toggleDetails() {
    this.mainDetailsToggle.open ? setTimeout(() => {
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      document.body.addEventListener("click", this.onBodyClickEvent);
    }) : (
      this.elements.successMessage.classList.add("hidden"),
      this.elements.successMessage.textContent = "",
      this.elements.shareSummary.focus()
    );
  }
  copyToClipboard() {
    navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
      this.elements.successMessage.classList.remove("hidden");
      this.elements.successMessage.textContent = theme.accessibilityStrings.shareSuccess;
    });
  }
  updateUrl(url) {
    this.urlToShare = url;
    this.elements.urlInput.value = url;
  }
  onBodyClick(event) {
    this.contains(event.target) || this.close();
  }
  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", false);
    document.body.removeEventListener("click", this.onBodyClickEvent);
  }
});
